import { useQuery } from '@tanstack/react-query'
import { createApiCall } from 'services'
import type { ProductsLastImport } from 'types'

type UseProductsLastImportParams = {
  company_id?: string
}

type UseProductsLastImportResult = {
  data: ProductsLastImport | null
  isLoading: boolean
  isError: boolean
  error: Error | null
  refetch: () => void
}

export const useProductsLastImport = (
  params?: UseProductsLastImportParams,
  options?: { enabled?: boolean }
): UseProductsLastImportResult => {
  const query = useQuery({
    queryKey: ['products', 'last-import', params?.company_id],
    queryFn: async () => {
      const response = await createApiCall({
        method: 'GET',
        url: '/products/admin/last-import',
        params: params?.company_id ? { company_id: params.company_id } : undefined,
      })
      return response.data as ProductsLastImport
    },
    enabled: options?.enabled !== false,
    staleTime: 1000 * 60 * 2, // 2 minutes - import status changes frequently
  })

  return {
    data: query.data || null,
    isLoading: query.isLoading,
    isError: query.isError,
    error: query.error,
    refetch: query.refetch,
  }
}
